import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'selectConnectionComp',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default
  },
  props: {
    appId: {
      type: String,
      required: false,
      default: ''
    }
  },
  mixins: [users],
  data: function () {
    return {
      lang: '',
      active: 'first',
      first: false,
      second: false,
      firstStepError: null,

      connections: [],
      connectionsCols: [],
      ResultColumns: [],
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      keyColumn: 'connectionId',
      noDataFound: false,

      towns: [],
      townSelected: -1,
      townships: [],
      townshipSelected: -1,
      searchConnectionId: null,
      searchConnection: '',
      searchConnectionNumber: null,
      searchMeter: '',
      searchMeterId: -1,
      searchMeterType: '',
      searchMeterRef: '',
      searchCustomerName: '',
      searchCustomerKey: '',
      searchCustomerIdNumber: '',
      searchPropertyId: -1,
      searchPropertyReference: '',
      searchBookNumber: '',
      searchWalkNumber: null,
      searchSequence: '',
      searchOwnerCustomerKey: '',
      searchCustomerTelephoneNumber: '',
      searchCustomerCellPhoneNumber: '',
      searchAddress: '',
      searchConnectionStatus: 0,
    }
  },
  created() {
    this.getLookups();
    this.fillConnectionsCols();
  },
  watch: {
    
  },
  methods: {
    resetFilters() {
      this.connectionIDs = [];
      this.connections = [];
      this.currentConnections = [];

      this.searchConnectionId = null;
      this.searchConnection = '';
      this.searchConnectionNumber = null;
      this.searchMeter = '';
      this.searchMeterId = -1;
      this.searchMeterType = '';
      this.searchMeterRef = '';
      this.searchCustomerName = '';
      this.searchCustomerKey = '';
      this.searchCustomerIdNumber = '';
      this.searchPropertyId = -1;
      this.searchPropertyReference = '';
      this.searchBookNumber = '';
      this.searchWalkNumber = null;
      this.searchSequence = '';
      this.searchOwnerCustomerKey = '';
      this.searchCustomerTelephoneNumber = '';
      this.searchCustomerCellPhoneNumber = '';
      this.searchAddress = '';
      this.searchConnectionStatus = 0;

      this.townSelected = -1;
      this.townshipSelected = -1;
    },
    fillConnectionsCols() {
      this.connectionsCols.push({ dataField: 'townshipStr', caption: this.$t('activities.township') });
      this.connectionsCols.push({ dataField: 'townStr', caption: this.$t('activities.town') });
      this.connectionsCols.push({ dataField: 'propertyReference', caption: this.$t('activities.propertyReference') });
      this.connectionsCols.push({ dataField: 'connectionNumber', caption: this.$t('activities.connectionNumber') });
      this.connectionsCols.push({ dataField: 'connectionStatusStr', caption: this.$t('activities.status') });
      this.connectionsCols.push({ dataField: 'meterRef', caption: this.$t('activities.meterRef') });
      this.connectionsCols.push({ dataField: 'bookNumber', caption: this.$t('activities.bookNumber') });
      this.connectionsCols.push({ dataField: 'walkNumber', caption: this.$t('activities.walkNumber') });
      this.connectionsCols.push({ dataField: 'fSequence', caption: this.$t('activities.telNo') });
      this.connectionsCols.push({ dataField: 'customerName', caption: this.$t('activities.name') });
      this.connectionsCols.push({ dataField: 'customerKey', caption: this.$t('activities.account') });
      this.connectionsCols.push({ dataField: 'customerTelephoneNumber', caption: this.$t('activities.telNo') });
      this.connectionsCols.push({ dataField: 'customerCellPhoneNumber', caption: this.$t('activities.cellPhoneNo') });
      this.connectionsCols.push({ dataField: 'address', caption: this.$t('activities.address') });
    },
    getLookups() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };
      axios.post('/CaptureConnectionDetailsActivity/GetBulkParameters', parameter)
        .then(response => {
          if (response.status == 200) {
            //console.log(response.data);
            this.towns = response.data.item.towns;
            this.townships = response.data.item.townships;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    getConnections() {
      var criteria = {
        townId: this.townSelected,
        townStr: '',
        townshipId: this.townshipSelected,
        townshipStr: '',
        connectionId: this.searchConnectionId,
        connection: this.searchConnection,
        connectionNumber: this.searchConnectionNumber,
        meter: this.searchMeter,
        meterId: this.searchMeterId,
        meterType: this.searchMeterType,
        meterRef: this.searchMeterRef,
        customerName: this.searchCustomerName,
        customerKey: this.searchCustomerKey,
        customerIdNumber: this.searchCustomerIdNumber,
        propertyId: this.searchPropertyId,
        propertyReference: this.searchPropertyReference,
        bookNumber: this.searchBookNumber,
        walkNumber: this.searchWalkNumber,
        sequence: this.searchSequence,
        ownerCustomerKey: this.searchOwnerCustomerKey,
        customerTelephoneNumber: this.searchCustomerTelephoneNumber,
        customerCellPhoneNumber: this.searchCustomerCellPhoneNumber,
        address: this.searchAddress,
        fSequence: this.searchFSequence,
        connectionStatus: this.searchConnectionStatus,
        connectionStatusStr: '',
      };
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Filters: criteria,
        Options: this.options
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/CaptureConnectionDetailsActivity/GetBulkConnections', parameter)
        .then(response => {
          if (response.status == 200) {

            if (response.data.items.length == 0) {
              this.connections = [];
              this.noDataFound = true;
            }
            else {
              this.connections = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
              this.noDataFound = false;
            }

            //console.log(this.connections);
            this.active = 'second';
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getConnections();
    },
    onSelectConnection(info) {
      var conn = info.data;
      if ((conn === null) || (conn === undefined))
        return;

      //console.log(info);
      this.$emit('selectConnectionDone', info.data);

      //this.connection.address = conn.address;
      //this.connection.bookNumber = conn.bookNumber;
      //this.connection.connection = conn.connection;
      //this.connection.connectionId = conn.connectionId;
      //this.connection.connectionNumber = conn.connectionNumber;
      //this.connection.connectionStatus = conn.connectionStatus;
      //this.connection.connectionStatusStr = conn.connectionStatusStr;
      //this.connection.customerCellPhoneNumber = conn.customerCellPhoneNumber;
      //this.connection.customerIdNumber = conn.customerIdNumber;
      //this.connection.customerKey = conn.customerKey;
      //this.connection.customerName = conn.customerName;
      //this.connection.customerTelephoneNumber = conn.customerTelephoneNumber;
      //this.connection.fSequence = conn.fSequence;
      //this.connection.meter = conn.meter;
      //this.connection.meterId = conn.meterId;
      //this.connection.meterRef = conn.meterRef;
      //this.connection.meterType = conn.meterType;
      //this.connection.propertyId = conn.propertyId;
      //this.connection.propertyReference = conn.propertyReference;
      //this.connection.townId = conn.townId;
      //this.connection.townStr = conn.townStr;
      //this.connection.townshipId = conn.townshipId;
      //this.connection.townshipStr = conn.townshipStr;
      //this.connection.walkNumber = conn.walkNumber;

      //this.selectConnection();
    },
  },
}
